import React from "react";
import { Form, Row, Col } from "react-bootstrap";
import * as Yup from "yup";
import DateTimeInputFormik from "../../../../components/UI/DateTimeInput/DateTimeInputFormik";
import TextInputFormik from "../../../../components/UI/TextInput/TextInputFormik";
import useAcoesDemonstrativo from "../hooks/useAcoesDemonstrativo";
import TextInputMoneyFormik from "../../../../components/UI/TextInput/TextInputMoneyFormik";

const validationSchema = Yup.object().shape({
  sqAcaoFiscal: Yup.string().default(""),
  sqItemOcorrencia: Yup.string().default(""),
  sqItem: Yup.string().default(""),
  txReferencia: Yup.string().default(""),
  nuItem: Yup.string().default(""),
  dtEmissao: Yup.string().default(""),
  dtVencimento: Yup.string().default(""),
  sqUf: Yup.string().default(""),
  nuCnpjRemet: Yup.string().default(""),
  vlIcmsRecolhido: Yup.string().default(""),
  vlIcmsCalculado: Yup.string().default(""),
  vlIcms: Yup.string().default(""),
  txJustificativa: Yup.string().default(""),
  txChave: Yup.string().default(""),
});

const initialValues = {};
validationSchema._nodes.forEach((key) => {
  initialValues[key] = "";
});

const DemonstrativoS = ({ formik }) => {
  const { calculaDataVencimento, handleMoneyChange } = useAcoesDemonstrativo({ formik });

  return (
    <>
      <Row>
        <Form.Group className="mb-3" as={Col} sm={12} md={4}>
          <Form.Label>Nº Série ECF:</Form.Label>
          <TextInputFormik formik={formik} field="nuSerieEcf" type="text" />
        </Form.Group>
        <Form.Group className="mb-3" as={Col} sm={12} md={4}>
          <Form.Label>N° Redução Z:</Form.Label>
          <TextInputFormik formik={formik} field="nuReducaoZ" type="text" />
        </Form.Group>
        <Form.Group className="mb-3" as={Col} sm={12} md={4}>
          <Form.Label>Data Redução Z:</Form.Label>
          <DateTimeInputFormik formik={formik} field="dtReducaoZ" evento={calculaDataVencimento} />
        </Form.Group>
      </Row>
      <Row>
        <Form.Group className="mb-3" as={Col} sm={12} md={4}>
          <Form.Label>Data de Vencimento:</Form.Label>

          <DateTimeInputFormik formik={formik} field="dtVencimento" />
        </Form.Group>
        <Form.Group className="mb-3" as={Col} sm={12} md={4}>
          <Form.Label>Valor da Base de Cálculo (R$):</Form.Label>
          <TextInputMoneyFormik
            formik={formik}
            field="vlBaseCalculo"
            type="number"
            prefix=" "
            onChange={handleMoneyChange}
          />
        </Form.Group>
        <Form.Group className="mb-3" as={Col} sm={12} md={4}>
          <Form.Label>Alíquota Memória Fiscal (%):</Form.Label>
          <TextInputMoneyFormik
            formik={formik}
            field="aliquotaMemoriaFiscal"
            type="number"
            prefix=" "
            onChange={handleMoneyChange}
          />
        </Form.Group>
      </Row>
      <Row>
        <Form.Group className="mb-3" as={Col} sm={12} md={4}>
          <Form.Label>Alíquota Irregular (%):</Form.Label>
          <TextInputMoneyFormik
            formik={formik}
            field="aliquotaIrregular"
            type="number"
            prefix=" "
            onChange={handleMoneyChange}
          />
        </Form.Group>
        <Form.Group className="mb-3" as={Col} sm={12} md={4}>
          <Form.Label>Alíquota Correta (%):</Form.Label>
          <TextInputMoneyFormik
            formik={formik}
            field="aliquotaCorreta"
            type="number"
            prefix=" "
            onChange={handleMoneyChange}
          />
        </Form.Group>
        <Form.Group className="mb-3" as={Col} sm={12} md={4}>
          <Form.Label>ICMS a Recolher (R$):</Form.Label>
          <TextInputMoneyFormik
            formik={formik}
            field="vlIcmsRecolhido"
            type="number"
            prefix=" "
            onChange={handleMoneyChange}
            disable
          />
        </Form.Group>
      </Row>
    </>
  );
};

export default DemonstrativoS;
